import axios from "axios";
import { GetAllManipulationDetailFiltersDTO, GetAllManipulationDetailsDTO, ManipulationDetailDTO } from "./dto";
import { ManipulationDetailService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";

export class ManipulationDetailServiceImpl implements ManipulationDetailService {

    public CreateManipulationDetail(data: ManipulationDetailDTO): Promise<void> {
        return axios.post("/api/gg-manipulation-detail",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllManipulationDetails(filters: GetAllManipulationDetailFiltersDTO): Promise<GetAllManipulationDetailsDTO> {
        return axios.get("/api/gg-manipulation-detail", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                ggNotificationId: filters.ggNotificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetManipulationDetailById(id: string): Promise<ManipulationDetailDTO> {
        return axios.get("/api/gg-manipulation-detail/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public DeleteManipulationDetail(id: string): Promise<void> {
        return axios.delete("/api/gg-manipulation-detail/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}